app.controller("StudentNewSelectionLiteController", [
    "$scope", "Socket", "Students", "StSubject", "$uibModal", "AuthService", "ProgramService", "StaticData", "$state", "$q", "FreshModal", "toastr",
    function ($scope, Socket, Students, StSubject, $uibModal, AuthService, ProgramService, StaticData, $state, $q, FreshModal, toastr) {

        $scope.Math = window.Math;
        $scope.selectedCredits = 0;
        $scope.loadingGroup = null;

        AuthService.getUserData().then(function (data) {
            var student = _.find(data.profiles, {state: 'active', type: 'student'});

            $scope.minCredits = student.info.minimalCredits;
            if (!AuthService.user.userConfig.informed) $state.go("student-new.selection-instruction", {});
        });

        StaticData.getSystemParam("maxCreditsPerSemester").then(function (data) {
            $scope.maxCredits = data;
        });

        StaticData.getItemsByKey("container_types").then(function (data) {
            // $scope.containerTypes = data;
            $scope.containerTypesMap = _.keyBy(data, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            // $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy(buildings, '_id');
        });

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.daysMap = _.keyBy(days, '_id');
        });

        load();

        function load() {
            Students.selectionAvailable().then(function (selections) {
                $scope.groupedSelections = _(selections).filter(function (selection) {
                    return !selection.state;
                }).groupBy('studentState').value();

                $scope.currentSelections = _.filter(selections, function (selection) {
                    return !!selection.state;
                });

                $scope.selectedCredits = _($scope.currentSelections).sumBy(function (selection) {
                    return selection.wrapper.credits;
                });
            })
        }

        $scope.selectSubject = function (subject) {
            // before loading
            subject.loading = true;
            Students.selectionSessions(subject.activation._id).then(function (sessions) {
                //after loading
                $scope.saveDisabled = true;
                if ($scope.selectedSubject) $scope.selectedSubject.active = false;
                subject.loading = false;
                subject.active = true;
                $scope.sessions = sessions;
                $scope.selectedSubject = subject;
                $scope.selectedSeminar = null;
                $scope.selectedLecture = null;
            }).catch(function (err) {
                console.error(err);
                alert('დაფიქსირდა შეცდომა!');
            });
        };

        $scope.selectedSubjectClass = function (subjectState) {
            if (subjectState === 'proved') return ' proved-selected-subject ';
            else if (subjectState === 'processing') return ' pending-selected-subject ';
            else if (subjectState === 'not_proved') return ' not-proved-selected-subject ';
            return ' ';
        };

        $scope.selectionSubjectClasses = function (subject) {
            var selectionSubjectClass = '';
            if (subject.active) selectionSubjectClass += ' active ';
            if (subject.studentState === 'normal') selectionSubjectClass += ' normal-subject ';
            else if (subject.studentState === 'critical') selectionSubjectClass += ' critical-subject ';
            else if (subject.studentState === 'important') selectionSubjectClass += ' important-subject ';
            // else if (subjectState === 'blocked') selectionSubjectClass += ' blocked-subject ';

            return selectionSubjectClass;
        };

        function checkSessionGroup(group) {
            return Students.checkGroupCollision(group);
        }

        function alertForCollision(collision) {
            FreshModal.open({
                controller: "GroupCollisionAlertController",
                templateUrl: _pb + 'student-new/group-collision-alert.html',
                resolve: {
                    collision: function () {
                        return collision;
                    }
                }
            }).then(function (result) {
            }, function (result) {
                if (result) {
                    Students.chooseSelection(subject.activation._id, $scope.selectedLecture._id, $scope.selectedSeminar._id).then(function (resp) {
                        $scope.loading = false;
                        load();
                    });
                }
            }).catch(function (err) {
                console.error(err)
            });
        }

        $scope.toggleSeminar = function (seminar) {
            if ($scope.selectedSeminar) {
                $scope.selectedSeminar = null;
                $scope.saveDisabled = true;
                return;
            }
            $scope.loadingGroup = seminar._id;
            checkSessionGroup(seminar._id).then(function (collisions) {
                $scope.loadingGroup = null;
                if (collisions.length) {
                    alertForCollision(collisions[0]);
                    return;
                }
                if (seminar.maxStudents - seminar.selectedCount > 0) {
                    $scope.selectedSeminar = seminar;
                    if ($scope.selectedLecture || !$scope.sessions.lectures.length) $scope.saveDisabled = false;
                }
            });

        };

        $scope.toggleLecture = function (lecture) {
            if ($scope.selectedLecture) {
                $scope.selectedLecture = null;
                $scope.saveDisabled = true;
                return;
            }
            $scope.loadingGroup = lecture._id;
            checkSessionGroup(lecture._id).then(function (collisions) {
                $scope.loadingGroup = null;
                if (collisions.length) {
                    alertForCollision(collisions[0]);
                    return;
                }
                if (lecture.maxStudents - lecture.selectedCount > 0) {
                    $scope.selectedLecture = lecture;
                    if ($scope.selectedSeminar || !$scope.sessions.seminars.length) $scope.saveDisabled = false;
                }
            });
        };

        $scope.save = function () {
            $scope.loading = true;
            var subject = $scope.selectedSubject;

            FreshModal.open({
                controller: "ConfirmSelectionWindowController",
                templateUrl: _pb + 'student-new/confirm-selection-window.html'
            }).then(function (result) {
                $scope.loading = false;
            }, function (result) {
                if (result === 'confirm') {
                    Students.chooseSelection(
                        subject.activation._id,
                        $scope.selectedLecture ? $scope.selectedLecture._id : null,
                        $scope.selectedSeminar ? $scope.selectedSeminar._id : null
                    ).then(function (resp) {
                        load();
                        $scope.loading = false;
                    }, function (err) {
                        console.log(err)
                        if(err.data === 'No more place on lecture') {
                            toastr.error('',"არჩეულ ჯგუფებში თავისუფალი ადგილი არ არის");
                        }
                    });
                }
            }).catch(function (error) {
                console.error(error);
                $scope.loading = false;

            });
        };

        $scope.showInstruction = function () {
            $state.go("student-new.selection-instruction", {});
        }
    }
]);
